export default __webpack_public_path__ + "static/media/profile-image.d548ae45.gif";